import { useDomain } from '@useDomain';

import FabNavbar from "../organizationCustomWebsite/fab/FabNavbar";
import DefaultNavbar from "../organizationCustomWebsite/default/DefaultNavbar";

function DynamicOrgNavbar() {
 const { slug, domain, organization } = useDomain();

 if (!organization) {
  return null; // or just return null
 }


 if (slug === "fastactionbasketball" || domain === "fastactionbasketball.com") {
  return <FabNavbar />;
 }
 if (slug === "hipppie3" || domain === "hipppie3.com") {
  console.log('✅ Loading FabHomepage');
  return <FabNavbar />;
 }


 return <DefaultNavbar />;
}

export default DynamicOrgNavbar;
